import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

import { WikiService } from '../../../../widgets/wiki/services/wiki.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { MarkdownEditorService } from '../../../services/core.markdown-editor.service';

/**
 * Read-only view of a single user notebook page, reachable by a shareable URL
 * (/:unixName/notebook/:pagename). No authentication is forced: the backend serves
 * the page when it is public (or to the owner / a site admin) and returns 403
 * otherwise, in which case we show an access-denied message.
 */
@Component({
  selector: 'user-notebook-page',
  template: require('./user.notebook-page.component.html')
})
export class UserNotebookPageComponent implements OnInit {
  unixName: string;
  pagename: string;

  loading: boolean = true;
  denied: boolean = false;
  notFound: boolean = false;
  page: any = null;
  content: string = '';

  @ViewChild('pageMarkdownEl', { read: ElementRef, static: false }) pageMarkdownElRef?: ElementRef;

  constructor(
    private stateService: StateService,
    private wikiService: WikiService,
    private translateService: GfTranslateService,
    private markdownEditorService: MarkdownEditorService
  ) {}

  onMarkdownReady(): void {
    this.markdownEditorService.enhanceStaticHtml(this.pageMarkdownElRef?.nativeElement);
  }

  ngOnInit(): void {
    this.unixName = this.stateService.params.unixName;
    this.pagename = this.stateService.params.pagename;
    this.load();
  }

  private load(): void {
    this.loading = true;
    // Listing by user returns only the pages this visitor may read (public, or
    // owner/admin). Anything else is effectively private and yields "not found".
    this.wikiService.fetch({ user: this.unixName })
      .then((response: any) => {
        const pages = Array.isArray(response) ? response : _.get(response, 'items', []);
        this.page = _.find(pages, (p: any) => p.pagename === this.pagename);
        if (!this.page) {
          this.loading = false;
          this.notFound = true;
          return;
        }
        return this.wikiService.page(this.page.id, { editable: true })
          .then((res: any) => {
            this.content = res.editableContent || '';
            this.loading = false;
          });
      })
      .catch((err: any) => {
        this.loading = false;
        if (err && (err.status === 401 || err.status === 403)) {
          this.denied = true;
        } else {
          this.notFound = true;
        }
      });
  }
}
